import {Timestamp} from '@firebase/firestore';
import dayjs from "dayjs";

export function isFutureTimestamp(timestamp: Timestamp) {
  return dayjs(timestamp.toMillis()).isAfter(dayjs());
}
